import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import * as dotenv from 'dotenv';
import Interceptors from './interceptors';

dotenv.config();

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export const apiEcommerce = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ECOMMERCE
});
export const apiGeo = axios.create({
  baseURL: process.env.REACT_APP_API_GEO_URL
});
export const apiSession = axios.create({
  baseURL: process.env.REACT_APP_API_SESSION_URL
});
export const apiStatus = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});
export const apiGfp = axios.create({
  baseURL: process.env.REACT_APP_API_URL_GFP
});
export const apiRfid = axios.create({
  baseURL: process.env.REACT_APP_API_RFID_URL
});

api.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error)
);
apiEcommerce.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error)
);
apiEcommerce.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config)
);
apiGeo.interceptors.response.use(
  (response: AxiosResponse<any>) => response,
  (error: any) => Interceptors.onError(error)
);

apiSession.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponseApiSession(response),
  (error: any) => Interceptors.onError(error)
);

apiGfp.interceptors.response.use(
  (response: AxiosResponse<any>) => response,
  (error: any) => Interceptors.onError(error)
);

apiRfid.interceptors.response.use(
  (response: AxiosResponse<any>) => response,
  (error: any) => Interceptors.onError(error)
);

api.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config)
);
apiStatus.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error)
);
apiStatus.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequestStatus(config)
);
apiGeo.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config)
);
apiSession.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config)
);
apiGfp.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config)
);
apiRfid.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config)
);

export default api;
